<template>
  <div>
    <v-row>
      <v-col
        cols="6"
        class="pb-0 pr-sm-6"
      >
        <v-alert
          v-if="firstUrl.error"
          type="error"
          text
        >
          {{ firstUrl.error }}
        </v-alert>
        <template v-else>
          <h2 style="font-size: 24px;">
            {{ firstUrl.title }}
          </h2>
          <a target="_blank">{{ firstUrl.canonical }}</a>
          <p>{{ firstUrl.description }}</p>
        </template>
      </v-col>
      <v-divider
        class="hidden-xs-only"
        vertical
      />
      <v-col
        cols="6"
        class="pb-0 pl-sm-6"
      >
        <v-alert
          v-if="secondUrl.error"
          type="error"
          text
        >
          {{ secondUrl.error }}
        </v-alert>
        <template v-else>
          <h2 style="font-size: 24px;">
            {{ secondUrl.title }}
          </h2>
          <a target="_blank">{{ secondUrl.canonical }}</a>
          <p>{{ secondUrl.description }}</p>
        </template>
      </v-col>
    </v-row>

    <v-row v-if="bothParsed">
      <v-col
        cols="6"
        class="pt-0 pr-sm-6"
      >
        <PublishedModifiedRow :value="firstUrl" />
        <MoreMetaData :value="firstUrl" />
      </v-col>
      <v-divider
        class="hidden-xs-only"
        vertical
      />
      <v-col
        cols="6"
        class="pt-0 pl-sm-6"
      >
        <PublishedModifiedRow :value="secondUrl" />
        <MoreMetaData :value="secondUrl" />
      </v-col>
    </v-row>

    <v-row v-if="bothParsed">
      <v-col
        cols="6"
        class="pr-sm-6"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <TileComponent
              title="Word Count"
              :text="firstUrl.wordCount"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <TileComponent
              title="Image Count"
              :text="firstUrl.imgCount"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-divider
        class="hidden-xs-only"
        vertical
      />
      <v-col
        cols="6"
        class="pl-sm-6"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <TileComponent
              title="Word Count"
              :text="secondUrl.wordCount"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <TileComponent
              title="Image Count"
              :text="secondUrl.imgCount"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-if="bothParsed">
      <v-col
        cols="6"
        class="pr-sm-6"
      >
        <v-img
          class="mb-4"
          v-if="firstUrl.og && firstUrl.og.ogImage"
          :src="firstUrl.og.ogImage"
        />
      </v-col>
      <v-divider
        class="hidden-xs-only"
        vertical
      />
      <v-col
        cols="6"
        class="pl-sm-6"
      >
        <v-img
          class="mb-4"
          v-if="secondUrl.og && secondUrl.og.ogImage"
          :src="secondUrl.og.ogImage"
        />
      </v-col>
    </v-row>

    <v-row v-if="bothParsed">
      <v-col
        class="my-6 section-heading"
        cols="12"
      >
        <h2 class="section-text my-3 text-center font-weight-light">
          Content Outline & Headings 
        </h2>
      </v-col>
      <v-col
        cols="6"
        class="pr-sm-6 text-left"
      >
        <OutlineView
          :h1="firstUrl.h1"
          :h1-similar="firstUrl.h1Similar"
          :toc="firstUrl.toc"
        />
      </v-col>
      <v-divider
        class="hidden-xs-only"
        vertical
      />
      <v-col
        cols="6"
        class="pl-sm-6  text-left"
      >
        <OutlineView
          :h1="secondUrl.h1"
          :h1-similar="firstUrl.h1Similar"
          :toc="secondUrl.toc"
        />
      </v-col>
    </v-row>
    <v-row v-if="bothParsed">
      <v-col
        class="my-6 section-heading"
        cols="12"
      >
        <h2 class="section-text my-3 text-center font-weight-light">
          Frequent Terms
        </h2>
      </v-col>
      <v-col
        cols="6"
        class="pr-sm-6"
      >
        <TopicsView :items="topics[0]" />
      </v-col>
      <v-divider
        class="hidden-xs-only"
        vertical
      />
      <v-col
        cols="6"
        class="pl-sm-6"
      >
        <TopicsView :items="topics[1]" />
      </v-col>
    </v-row>

    <v-row v-if="bothParsed">
      <v-col
        class="my-6 section-heading"
        cols="12"
      >
        <h2 class="section-text my-3 text-center font-weight-light">
          FAQ Schema
        </h2>
      </v-col>
      <v-col
        cols="6"
        class="pr-sm-6"
      >
        <FaqOnPage :items="firstUrl.faq_on_page" />
      </v-col>
      <v-divider
        class="hidden-xs-only"
        vertical
      />
      <v-col
        cols="6"
        class="pl-sm-6"
      >
        <FaqOnPage :items="secondUrl.faq_on_page" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PublishedModifiedRow from './PublishedModifiedRow.vue';
import MoreMetaData from './MoreMetaData.vue';
import TileComponent from '../TileComponent.vue';
import TopicsView from './TopicsView.vue';
import FaqOnPage from './FaqOnPage.vue';
import OutlineView from './OutlineView.vue';

export default {
  components: {
    TileComponent,
    PublishedModifiedRow,
    TopicsView,
    FaqOnPage,
    OutlineView,
    MoreMetaData
},
  props: {
    results: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    firstUrl() {
      return this.results[0];
    },
    secondUrl() {
      return this.results[1];
    },
    bothParsed() {
      if (this.results[0] && this.results[1]) {
        return !this.results[0].error && !this.results[1].error
      }

      return false
    },
    topics() {
      const first = this.getTopicsObj(this.results[0])
      const second = this.getTopicsObj(this.results[1])
      return [
        Object.keys(first).map((topic) => ({
          topic,
          tf:first[topic].tf,
          color: second[topic] ? 'green' : null
        })),
        Object.keys(second).map((topic) => ({
          topic,
          tf:second[topic].tf,
          color: first[topic] ? 'green' : null
        }))
      ];
    }
  },
  methods: {
    getTopicsObj(result) {
      const topicsObj = {}

      if (result.kwBody) {
        for (let i = 0; i < result.kwBody.length; i++) {
          const { term, tf } = result.kwBody[i];
          topicsObj[term] = {
            term:term,
            tf:tf
          }
        }
      }

      return topicsObj
    }
  }
}
</script>

<style scoped>
.main-col:nth-child(1) {
  padding-right: 40px;
}

.main-col:nth-child(3) {
  padding-left: 40px;
}

.section-heading{
  background-color: #F8F8F8;
}

.section-text {
  font-size: 24px;
}
</style>